<template>
  <div class="inteBox">
    <intNavheader activeNameCheck="eight"></intNavheader>
    <div class="titleTopLine"></div>
    <div class="titleTopCenter noflex-l-s">
      <div class="titleTopCenterLeft">
        <div :class="activeName == 1 ? 'left-btn1' : 'left-btn2'" @click="changeState(1)">已预约</div>
        <div :class="activeName == 2 ? 'left-btn1' : 'left-btn2'" @click="changeState(2)">已完成</div>
        <div :class="activeName == -2 ? 'left-btn1' : 'left-btn2'" @click="changeState(-2)">已退号</div>
      </div>
      <div class="titleTopCenterCenter">
        <div class="titleTopCenterCenterTop">
          <div class="Content1Title">门诊挂号预约列表</div>
          <div class="flex-l" style="margin-top: 20px">
            <el-form :model="searchForm" :inline="true">
              <el-form-item>
                <el-date-picker v-model="searchForm.datepicker" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions0" size="small" style="margin-right: 10px; width: 260px" @change="Search"> </el-date-picker>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="searchForm.payType" style="width: 100%" placeholder="支付方式" size="small" @change="Search">
                  <el-option v-for="item in optionsPayType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="用户手机号/患者名称" @keyup.enter.native="Search" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="Search()">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }" height="calc(100vh - 300px)">
            <el-table-column prop="orderNumber" label="订单编号"></el-table-column>
            <el-table-column prop="scheduleDate" label="预约时间" align="center" width="180px">
              <template slot-scope="scope">
                <p style="font-weight: bold;">{{ scope.row.scheduleDate.split('T')[0] }} {{ formatWeek(scope.row.scheduleDate) }} {{scope.row.timePeriod==1?'上午':'下午'}}</p>
                <p style="font-weight: bold;">{{ scope.row.startTime}} ~ {{ scope.row.endTime  }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="userName" label="用户账号" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.userName }}</p>
                <p>{{ scope.row.userPhone }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="patientName" label="患者姓名" align="center"> </el-table-column>
            <el-table-column prop="disease" label="患者病症" align="center">
              <template slot-scope="scope">
                {{ scope.row.disease ? scope.row.disease : "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="payMoney" label="订单金额(元)" align="center">
              <template slot-scope="scope">
                {{ scope.row.payMoney ? scope.row.payMoney.toFixed(2) : 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="payType" label="支付方式" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.payType == 0">余额</p>
                <p v-if="scope.row.payType == 1">微信</p>
                <p v-if="scope.row.payType == 2">支付宝</p>
              </template>
            </el-table-column>
            <el-table-column prop="state" label="订单状态" align="center">
              <template slot-scope="scope">
                <p v-if="scope.row.state == 0">待支付</p>
                <p v-if="scope.row.state == 1">已预约</p>
                <p v-if="scope.row.state == 2">已完成</p>
                <p v-if="scope.row.state == -1">已取消</p>
                <p v-if="scope.row.state == -2">已退号</p>
              </template>
            </el-table-column>
            <el-table-column prop="addTime" label="下单时间" align="center" width="150px">
              <template slot-scope="scope">
                {{ scope.row.addTime | timefilters }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <span class="info optionBtn" @click="toOrderInfo(scope.row)">详情</span>
                <span class="primary optionBtn" @click="confirmData(scope.row)" v-if="scope.row.state == 1">确认到院</span>
                <span class="danger optionBtn" @click="RefuseBtn(scope.row)" v-if="scope.row.state == 1">退号</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="changePage" :page-size="pageSize" :current-page="pageIndex" :total="dataTotal" layout="total, prev, pager, next, jumper"></el-pagination>
        </div>
      </div>
    </div>
    <div class="titleTopLine"></div>

    <el-dialog title="退号" :visible.sync="refuseDialog" width="450px">
      <el-form class="dialog-form" :model="refuseForm" ref="refuseForm" :rules="rules" :label-width="formLabelWidth">
        <el-form-item prop="refusalReason">
          <el-input v-model="refuseForm.refusalReason" type="textarea" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CloseBtn('refuseForm')">取 消</el-button>
        <el-button type="primary" @click="SaveBtn('refuseForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import intNavheader from "../../components/intNavheader";
import { DoctorAppointment } from "@/components/Drug/DoctorAppointment";
export default {
  components: {
    intNavheader,
  },
  inject: ["reload"],
  data() {
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    return {
      DoctorAppointment: doctorAppointment,
      searchForm: {
        keyWord: "",
        datepicker: "",
        startTime: "",
        endTime: "",
        states: "1",
        payType: "-1",
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      options: [
        {
          value: "1",
          label: "已预约",
        },
        {
          value: "2",
          label: "已完成",
        },
        {
          value: "-2",
          label: "已退号",
        },
      ],
      optionsPayType: [
        {
          value: "-1",
          label: "全部",
        },
        {
          value: "0",
          label: "余额",
        },
        {
          value: "1",
          label: "微信",
        },
        {
          value: "2",
          label: "支付宝",
        },
      ],
      active: 1,
      activeName: 1,
      tableData: [],
      pageIndex: 1,
      dataTotal: 1,
      pageSize: 15,
      rules: {
        refusalReason: [{ required: true, message: "请填写退号原因", trigger: "blur" }],
      },
      refuseForm: {
        orderNumber: 0,
        refusalReason: "",
      },
      refuseDialog: false,
      formLabelWidth: "15px",
    };
  },
  created() {
    let activeName = JSON.parse(sessionStorage.getItem("activeName")) + "";
    if (activeName && activeName != "null") {
      sessionStorage.removeItem("activeName");
      this.activeName = activeName;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatWeek(date) {
      const d = new Date(date);
      return this.weekdays[d.getDay()];
    },
    CloseBtn(formName) {
      this.$refs[formName].resetFields();
      this.refuseDialog = false;
    },
    RefuseBtn(item) {
      var _this = this;
      _this.refuseDialog = true;
      _this.refuseForm = {
        orderNumber: item.orderNumber,
        refusalReason: "",
      };
    },
    SaveBtn(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          var item = this.refuseForm;
          _this.DoctorAppointment.DoctorRefundOrder(
            item.orderNumber,
            item.refusalReason,
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              _this.$refs[formName].resetFields();
              _this.refuseDialog = false;
              _this.getData();
            },
            function (err) {
              var jsonObj = JSON.parse(err.msg);
              // if (jsonObj.code == "400") {
              _this.$message({
                type: "error",
                message: jsonObj.msg,
              });
              // }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toOrderInfo(item) {
      sessionStorage.setItem("activeName", this.activeName);
      this.$router.push({
        path: "./SchedulingInfo",
        query: {
          orderId: item.orderNumber,
        },
      });
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getData();
    },
    changeState(active) {
      this.activeName = active;
      this.pageIndex = 1;
      this.getData();
    },
    Search() {
      this.pageIndex = 1;
      this.getData();
    },
    getData() {
      var _this = this;
      _this.tableData = [];
      var item = _this.searchForm;
      if (_this.searchForm.datepicker) {
        item.startTime = _this.searchForm.datepicker[0] + " 00:00:00";
        item.endTime = _this.searchForm.datepicker[1] + " 23:59:59";
      } else {
        item.startTime = "";
        item.endTime = "";
      }
      _this.DoctorAppointment.GetDoctorOrderList(
        this.activeName,
        item.startTime,
        item.endTime,
        item.payType,
        item.keyWord,
        this.pageIndex,
        this.pageSize,
        function (data) {
          _this.tableData = data.data.results;
          _this.pageIndex = data.data.pageIndex;
          _this.pageSize = data.data.pageSize;
          _this.dataTotal = data.data.dataTotal;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    confirmData(item) {
      var _this = this;
      _this.DoctorAppointment.CompleteOrder(
        item.orderNumber,
        function (data) {
          _this.$message({
            type: "success",
            message: "操作成功！",
          });
          _this.reload();
        },
        function (err) {
          var jsonObj = JSON.parse(err.msg);
          if (jsonObj.code == "400") {
            _this.$message({
              type: "error",
              message: jsonObj.msg,
            });
          }
        }
      );
    },
    goBack() {
      this.addtoNew = false;
    },
  },
};
</script>
<style scoped>
.pageBox {
  text-align: center;
  margin-top: 10px;
}
.inteBox {
  margin: 0;
  padding: 0;
  background-color: #f0f2f5;
}
.titleTop {
  padding: 0px 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titleTopLeft {
  width: 85%;
  display: flex;
  align-items: center;
}
.titleTopLeftImg {
  width: 123px;
  height: 24px;
}
.titleTopLeftImg img {
  width: 100%;
  height: 100%;
}
.tabBox {
  padding-left: 12%;
  margin-top: 10px;
}
.el-tabs__item {
  height: 60px;
  color: white !important;
  text-align: center;
  padding-top: 10px;
  font-size: 25px !important;
  background-color: #00afb5 !important;
  border: none !important;
}
.is-active {
  color: white !important;
  background-color: #00afb5 !important;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #ffffff !important;
}
.titleTopRight {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.titleTopRight div {
  margin-left: 10px;
}
.titleTopLine {
  width: 100%;
  height: 12px;
}
.titleTopCenter {
  width: 100%;
  /* height: 100; */
  display: flex;
}
.titleTopCenterLeft {
  width: 15%;
  background-color: #ffffff;
  /* padding-top: 30px; */
  /* max-height: 750px; */
  overflow: auto;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  /* margin-top: 0; */
}
.titleTopCenterCenter {
  width: 80%;
  border-radius: 6px;
  height: calc(100vh - 64px - 24px);
  overflow: auto;
}
.titleTopCenterCenterTop {
  background-color: #ffffff;
  padding: 0 40px;
  /* padding-top: 10px;
  padding-bottom: 10px; */
  height: 100%;
}
.left-btn1 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: #06add7;
  border-radius: 6px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.left-btn2 {
  width: 150px;
  height: 40px;
  line-height: 40px;
  background: rgba(255, 255, 255, 0);
  border-radius: 6px;
  border: 1px solid #06afd3;
  color: #06add7;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}
.flex-l {
  display: flex;
  align-items: center;
}
.flex-l-s {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.noflex-l-s {
  display: flex;
  justify-content: space-around;
}
.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Content1Title {
  padding: 20px 40px;
  padding-left: 0;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 0;
  text-align: left;
}
.titleTopLeftTableC {
  color: #06add7;
  cursor: pointer;
}
.ageInput {
  width: 80%;
}
.typeChecked {
  font-size: 14px;
  color: #ffffff;
  padding: 0px 15px;
  text-align: center;
  background: #00afb5;
  border-radius: 6px;
  cursor: pointer;
}
.notypeChecked {
  background: #f3f9f9;
  border: 1px solid #b9dcdd;
  padding: 0px 15px;
  border-radius: 6px;
  color: #00afb5;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.table3Box {
  border: 1px solid #b9dcdd;
  border-radius: 6px;
  padding: 30px;
  margin-top: 10px;
}
.titleTopright1Line {
  border-bottom: 1px dashed #999999;
}
.titleTopright1 {
  font-size: 16px;
  color: #06add7;
}
.stepInput {
  width: 60%;
  margin-right: 10px;
}
.titleTopCenterLeftBox {
  font-size: 18px;
  color: #06add7;
  border: 1px solid #06afd3;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}
.titleTopCenterLeftBoxno {
  font-size: 18px;
  color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 6px;
  width: 150px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin: 30px auto;
  cursor: pointer;
  /* margin-top: 0; */
}
::v-deep .el-pagination {
  padding: 10px 5px;
}
.drawer-box {
  padding: 30px;
}
.el-drawer {
  background-color: #ffffff !important;
  width: 550px !important;
}
.el-drawer__body {
  overflow: auto;
}
.detail-item {
  position: relative;
  margin-bottom: 20px;
}

.detail-item .detail-tit {
  font-size: 18px;
}

.detail-item > p {
  margin: 5px 0;
}

.detail-item > p span {
  display: inline-block;
  width: 100px;
  text-align: right;
}

.detail-item .status {
  position: absolute;
  right: 5px;
  top: 5px;
}

.detail-item .status .text-orange {
  color: orange;
}

.detail-item .status .text-blue {
  color: rgb(47, 0, 255);
}

.detail-item .status p.text-danger {
  color: red;
}

.detail-item .status p.text-succes {
  color: forestgreen;
}
</style>
